import MurmurHash3 from "murmurhash3js"

const mul_num = x => {
    return ((((x * 1289) & 0xffffffff) * 1406077) & 0xffffffff) >>> 0
}

class XORSHIFT128 {
    constructor(seed1, seed2, seed3, seed4) {
        if (seed2 === undefined) {
            this.x = MurmurHash3.x86.hash32(`${seed1}_0`) >>> 0
            this.y = MurmurHash3.x86.hash32(`${seed1}_1`) >>> 0
            this.z = MurmurHash3.x86.hash32(`${seed1}_2`) >>> 0
            this.w = MurmurHash3.x86.hash32(`${seed1}_3`) >>> 0
        } else if (seed3 === undefined) {
            this.x = ((mul_num(seed1 ^ (seed1 >>> 30)) + 1) & 0xffffffff) >>> 0
            this.y = ((mul_num(this.x ^ (this.x >>> 30)) + 2) & 0xffffffff) >>> 0
            this.z = ((mul_num(this.y ^ (this.y >>> 30)) + 3) & 0xffffffff) >>> 0
            this.w = ((mul_num(this.z ^ (this.z >>> 30)) + 4) & 0xffffffff) >>> 0
        } else {
            this.x = seed1
            this.y = seed2
            this.z = seed3
            this.w = seed4
        }
    }

    get_u32() {
        const t = this.x ^ (this.x << 11)
        this.x = this.y >>> 0
        this.y = this.z >>> 0
        this.z = this.w >>> 0
        this.w ^= (this.w >>> 19) ^ t ^ (t >>> 8)
        return this.w >>> 0
    }

    get_rand_int(min, max) {
        return min + parseInt(((max - min) * this.get_u32()) / 0x100000000)
    }

    convert_to_float(num) {
        const buffer = new ArrayBuffer(4)
        const bytes = new Uint8Array(buffer)
        bytes[0] = (num >> 24) & 0xff
        bytes[1] = (num >> 16) & 0xff
        bytes[2] = (num >> 8) & 0xff
        bytes[3] = (num >> 0) & 0xff
        const view = new DataView(buffer)
        return view.getFloat32(0, false)
    }

    get_rand_float(min, max) {
        return min + (this.convert_to_float((this.get_u32() >>> 9) | 0x3f800000) - 1.0) * (max - min)
    }

    get_state() {
        return [
            `0x${(this.x >>> 0).toString(16)}`,
            `0x${(this.y >>> 0).toString(16)}`,
            `0x${(this.z >>> 0).toString(16)}`,
            `0x${(this.w >>> 0).toString(16)}`,
        ]
    }

    get_raw_state() {
        return [this.x >>> 0, this.y >>> 0, this.z >>> 0, this.w >>> 0]
    }

    get_clone() {
        return new XORSHIFT128(this.x >>> 0, this.y >>> 0, this.z >>> 0, this.w >>> 0)
    }
}

export default XORSHIFT128
